import { useState } from 'react';
import { primaryBtn, screenShell } from '../screens/lesson/common';

const GOALS = ['Đi làm', 'Công việc & kinh doanh', 'Sở thích cá nhân', 'Mình chưa rõ'];

const CameraIcon = () => (
  <svg width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="var(--navy-300)" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 8a2 2 0 0 1 2-2h1l1.5-2h7L17 6h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" />
    <circle cx={12} cy={13} r={4} />
  </svg>
);

interface Props {
  /** Tên để trống nghĩa là bỏ qua — không gọi API đặt tên. */
  onDone: (displayName: string) => void;
  /** Tên sẵn có từ lúc đăng ký, nếu người dùng đã nhập. */
  initialName?: string;
  saving?: boolean;
  error?: string | null;
}

/** SCR-AUTH-06 — Tạo hồ sơ tối thiểu. Mọi câu hỏi đều bỏ qua được. */
export function CreateProfileScreen({ onDone, initialName = '', saving = false, error = null }: Props) {
  const [name, setName] = useState(initialName);
  const [goal, setGoal] = useState<number | null>(null);

  return (
    <div style={screenShell}>
      <div style={{ flex: 1, overflowY: 'auto', padding: '32px 24px 16px' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--ink)', margin: '0 0 24px', textAlign: 'center' }}>Cho chúng tôi biết về bạn</h1>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <button
            type="button"
            aria-label="Chọn ảnh đại diện"
            style={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              border: '2px dashed var(--navy-100)',
              background: 'var(--surface-tint)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <CameraIcon />
          </button>
        </div>

        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Tên của bạn"
          maxLength={80}
          style={{
            width: '100%',
            height: 52,
            borderRadius: 'var(--radius-control)',
            border: `1.5px solid ${error ? 'var(--error)' : 'var(--border-default)'}`,
            padding: '0 16px',
            fontSize: 16,
            fontFamily: 'var(--font-vi)',
            color: 'var(--ink)',
            outline: 'none',
            marginBottom: error ? 8 : 28,
            background: 'var(--surface-page)',
          }}
        />
        {error && (
          <div role="alert" style={{ fontSize: 13, color: 'var(--error)', lineHeight: 1.45, marginBottom: 20 }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--ink)' }}>Bạn học tiếng Nhật để làm gì?</div>
          <button
            type="button"
            onClick={() => onDone('')}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--font-vi)', fontWeight: 600, fontSize: 13, color: 'var(--navy-500)' }}
          >
            Bỏ qua
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {GOALS.map((g, i) => {
            const sel = goal === i;
            return (
              <button
                key={g}
                type="button"
                onClick={() => setGoal(i)}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  height: 52,
                  borderRadius: 'var(--radius-control)',
                  border: sel ? '2px solid var(--cta-default)' : '1.5px solid var(--border-default)',
                  background: sel ? 'rgba(0,91,150,0.08)' : 'var(--surface-page)',
                  padding: '0 16px',
                  cursor: 'pointer',
                  fontFamily: 'var(--font-vi)',
                  fontWeight: 600,
                  fontSize: 15,
                  color: 'var(--ink)',
                }}
              >
                {g}
              </button>
            );
          })}
        </div>
      </div>

      <div style={{ padding: '12px 24px 28px', borderTop: '1px solid var(--border-default)' }}>
        <button
          type="button"
          onClick={() => onDone(name.trim())}
          disabled={saving}
          style={{ ...primaryBtn, opacity: saving ? 0.6 : 1, cursor: saving ? 'progress' : 'pointer' }}
        >
          {saving ? 'Đang lưu…' : 'Bắt đầu học'}
        </button>
      </div>
    </div>
  );
}
